<template>
  <div class="wrapper">
    <c-input
      ref="periodPicker"
      v-model="localValue"
      :label="field.name"
      placeholder="00.00.0000 - 00.00.0000"
      type="period-without-fixed-intervals"
      icon="calendar"
      :required-mark="field.required"
      :icon-right="true"
      :clearable="true"
      :flip="true"
      :required="error"
      :required-message="error"
    />
  </div>
</template>

<script>
import CInput from "@/components/controls2/Input";
import { getRange } from "@/utils/date/ranges";

export default {
  components: { CInput },
  props: ["field", "value", "editable", "error"],
  data() {
    return {
      inited: false,
      localValue: "",
    };
  },
  watch: {
    localValue(v) {
      if (this.value === v) return;

      if (!v) this.$emit("input", ["", ""]);
      else {
        if (typeof v !== "string") return;

        const [from, to] = v.split("-");
        this.$emit("input", { value: [from.trim(), to.trim()] });
      }
      
      if (this.inited) this.$emit("change");
    },
    value(v) {
      this.setData(v);
    },
  },

  created() {
    if (this.value) this.setData(this.value);
  },

  methods: {
    setData(value) {
      if (!value) return;
      this.inited = false;

      const [from, to] = value.value || ["", ""];

      this.$nextTick(() => {
        this.$refs.periodPicker.period.start.input = from;
        this.$refs.periodPicker.period.end.input = to;

        const range = from && to ? getRange(from, to) : "";
        this.$refs.periodPicker.dateValue = range;

        this.$nextTick(() => {
          this.inited = true;
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  padding-top: 6px;
}
</style>
